import { Link } from "react-router-dom";
import type { Comic } from "@/types/comic";
import { formatCount } from "@/utils/comics";

interface ComicRowProps {
  comic: Comic;
}

export default function ComicRow({ comic }: ComicRowProps) {
  return (
    <Link
      to={`/detail/${comic.id}`}
      className="group flex gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:gap-4 md:p-4"
    >
      <div className="h-[104px] w-[78px] shrink-0 overflow-hidden rounded-md bg-secondary-100 md:h-[124px] md:w-[93px]">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title} - JMComic漫画`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-start justify-between gap-2">
          <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-700 md:text-base">
            {comic.title}
          </h3>
          <span
            className={`shrink-0 rounded px-1.5 py-0.5 text-[10px] font-semibold ${
              comic.status === "连载"
                ? "bg-primary-100 text-primary-800"
                : "bg-secondary-200 text-secondary-800"
            }`}
          >
            {comic.status}
          </span>
        </div>
        <p className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-foreground-500">
          <span>{comic.author}</span>
          <span className="text-background-400">|</span>
          <span>{comic.categoryName}</span>
          <span className="text-background-400">|</span>
          <span>{comic.region}</span>
          <span className="text-background-400">|</span>
          <span>共 {comic.chapterCount} 话</span>
        </p>
        <p className="mt-1.5 line-clamp-2-safe text-xs leading-relaxed text-foreground-500">
          {comic.intro}
        </p>
        <div className="mt-auto flex flex-wrap items-center justify-between gap-2 pt-2">
          <span className="flex items-center gap-1.5 text-[11px] font-medium text-primary-700">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>
            {comic.latestChapter}
          </span>
          <span className="flex items-center gap-3 text-[10px] text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatCount(comic.viewCount)}
            </span>
            <span>{comic.updatedAt}</span>
          </span>
        </div>
      </div>
    </Link>
  );
}